import { externalContentService } from '../services';
import { externalContentsConstants } from '../constants'

import { alertActions } from './alert.actions'

import { history } from '../helpers';

export const externalContentActions = {
    getExternalContentList,
    getExternalContentById,
    createContent,
    editContent,
    toggleFilter,
    deleteContent,
    resetExternalContent,
}

function setLoading(state) {
    return {
        type: externalContentsConstants.SET_EXTERNAL_CONTENT_LOADING,
        payload: state,
    };
}

function getExternalContentList(
    page = 1,
    query,
    limit,
    statusList = []
) {
    return dispatch => {
        dispatch({
            type: externalContentsConstants.GET_EXTERNAL_CONTENT_LIST_REQUEST
        });

        externalContentService.getExternalContentList(
            page,
            query,
            limit,
            statusList
        )
            .then((result) => {
                if (result && result.data) {
                    dispatch({
                        type: externalContentsConstants.GET_EXTERNAL_CONTENT_LIST_SUCCESS,
                        payload: result
                    })
                }
            })
    }
}

function getExternalContentById(id) {
    return dispatch => {
        dispatch(setLoading(true));

        externalContentService.getExternalContentById(id)
            .then((result) => {
                dispatch({
                    type: externalContentsConstants.SET_EXTERNAL_CONTENT_DATA,
                    payload: result
                });

                dispatch(setLoading(false));
            })
    }
}

function createContent(data) {
    return dispatch => {
        dispatch(setLoading(true));

        externalContentService.createContent(data)
            .then(
                () => {
                    dispatch(setLoading(false));
                    dispatch(alertActions.success('Novo conteúdo salvo com sucesso'));
                    history.push('/external-contents');
                },
                (error) => {
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function editContent(data, id) {
    return dispatch => {
        dispatch(setLoading(true));

        externalContentService.editContent(data, id)
            .then(
                () => {
                    dispatch(setLoading(false));
                    dispatch(alertActions.success('Seu conteúdo foi alterado com sucesso!'));
                    history.push('/external-contents');
                },
                (error) => {
                    if (error?.response?.data?.errors) {
                        if (error?.response?.data?.errors.indexOf('Já existe um conteúdo fixado') >= 0) {
                            dispatch(alertActions.error(
                                'Já existe um conteúdo fixado, é necessário desafixar este conteúdo para fixar um novo'
                            ))
                        } else {
                            dispatch(alertActions.error(error.response.data.errors));
                        }
                    }
                }
            )
    }
}

function deleteContent(id) {
    return (dispatch) => {
        externalContentService.deleteContent(id).then(
            () => {
                dispatch(getExternalContentList());
                dispatch(alertActions.success('Seu conteúdo foi deletado com sucesso!'));
            },
            (error) => {
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
}

function toggleFilter(filter) {
    return (dispatch) => {
        dispatch({
            type: externalContentsConstants.TOGGLE_FILTER,
            payload: {
                filter
            }
        })
    };
}

function resetExternalContent() {
    return dispatch => {
        dispatch({
            type: externalContentsConstants.SET_EXTERNAL_CONTENT_DATA,
            payload: {}
        })
    }
}